// „Notizen" (frontend/src/pages/Notes.tsx) — deutsche QUELLE.
//
// Die deutschen Texte stehen hier WÖRTLICH so, wie sie vorher im JSX standen:
// die bestehenden Playwright-Walks selektieren genau diese Beschriftungen
// (z. B. `button:has-text("Neue Notiz")` in modal-regression-walk.mjs). Eine
// „schönere Formulierung" wäre hier kein Feinschliff, sondern ein Testbruch.
//
// Bewusst NICHT hier: der Vorgabe-Text einer neu angelegten Notiz
// (`body_md: "Neue Notiz"` in Notes.tsx). Das ist INHALT, der in der Datenbank
// landet und volltext-indiziert wird (`to_tsvector('german', …)`), keine
// Beschriftung — docs/i18n.md §5.
export const notes = {
  // Sidebar / Filter
  alleNotizen: "Alle Notizen",
  kategorien: "Kategorien",
  tags: "Tags",
  kategorie: "Kategorie",
  keineKategorienHinweis: "Noch keine. Im Notiz-Text @name tippen, um anzulegen.",
  filterOeffnen: "Filter oeffnen",
  filter: "Filter",
  notizenFiltern: "Notizen filtern",
  keineKategorienOderTags: "Keine Kategorien oder Tags vorhanden.",

  // Liste
  suchePlatzhalter: "In Notizen suchen …",
  sucheAria: "In Notizen suchen",
  neueNotiz: "Neue Notiz",
  keineNotizen: "Noch keine Notizen",
  ersteNotizAnlegen: "Deine erste Notiz anlegen.",
  keineNotizAusgewaehlt: "Keine Notiz ausgewählt",
  keineNotizAusgewaehltHinweis: "Wähle links eine Notiz aus oder lege eine neue an.",
  leer: "(leer)",

  // Editor
  zurueckZurListe: "Zurueck zur Notes-Liste",
  zurueck: "Zurueck",
  wirdGespeichert: "wird gespeichert …",
  gespeichertUm: (zeit: string) => `gespeichert ${zeit}`,
  bearbeitetAm: (zeitpunkt: string) => `bearbeitet ${zeitpunkt}`,
  aufgabeVerlinkt: "Aufgabe verlinkt",
  inAufgabeUmwandeln: "In Aufgabe umwandeln",
  zuAufgabeMachen: "Zu Aufgabe machen",
  titelPlatzhalter: "Titel (optional)",
  notizTitelAria: "Notiz-Titel",
  inhaltPlatzhalter: "Schreib einfach drauflos.",
  notizInhaltAria: "Notiz-Inhalt",
  tagPlatzhalter: "#tag",
  tagEntfernen: (tag: string) => `Tag ${tag} entfernen`,
  // aria-label und title standen schon vorher unterschiedlich da (einmal ohne,
  // einmal mit Umlaut) — wörtlich übernommen, nicht stillschweigend vereinheitlicht.
  tagHinzufuegenAria: "Tag hinzufuegen",
  tagHinzufuegenTitel: "Tag hinzufügen",

  // Aktionen / Rückmeldungen
  notizLoeschenFrage: "Notiz löschen?",
  notizAngelegt: "Notiz angelegt",
  notizGeloescht: "Notiz gelöscht",
  verschobenNach: (kategorie: string) => `In „${kategorie}" verschoben`,
  kategorieEntfernt: "Kategorie entfernt",
  kategorieNichtGeaendert: "Kategorie nicht geändert",
  notizInAufgabeUmgewandelt: "Notiz in Aufgabe umgewandelt",
  promoteFehlgeschlagen: "Promote fehlgeschlagen",
  konnteNichtSpeichern: "Konnte nicht speichern",
};

export type NotesKatalog = typeof notes;
